/**
 * Constant mapping for HTML5 MediaError codes.
 */
let MediaErrorType;
/**
 * Returns true if the argument structurally matches an Error object.
 */

(function (MediaErrorType) {
  MediaErrorType[MediaErrorType["MEDIA_ERR_ABORTED"] = 1] = "MEDIA_ERR_ABORTED";
  MediaErrorType[MediaErrorType["MEDIA_ERR_NETWORK"] = 2] = "MEDIA_ERR_NETWORK";
  MediaErrorType[MediaErrorType["MEDIA_ERR_DECODE"] = 3] = "MEDIA_ERR_DECODE";
  MediaErrorType[MediaErrorType["MEDIA_ERR_SRC_NOT_SUPPORTED"] = 4] = "MEDIA_ERR_SRC_NOT_SUPPORTED";
})(MediaErrorType || (MediaErrorType = {}));

function isError(e) {
  return typeof e === 'object' && e !== null && 'name' in e && 'message' in e;
}
/**
 * Returns true if the argument is an AbortError.
 */

function isAbortError(e) {
  return toError(e).name === 'AbortError';
}
/**
 * Returns true if the argument is a MediaError (which is not an Error object).
 */

function isMediaError(e) {
  return typeof e === 'object' && e !== null && e.name === undefined && e.MEDIA_ERR_ABORTED === 1 && typeof e.code === 'number';
}
/**
 * Convert anything to an error object. If the input already looks like an
 * error object, then it's returned as is.
 */

function toError(e, context) {
  if (isError(e)) {
    return e;
  }

  return context ? new Error(`${context}: ${e}`) : new Error(`${e}`);
}
/**
 * Returns true if the media error is considered a fatal error.
 */

function isMediaErrorFatal(error) {
  return error.code !== error.MEDIA_ERR_ABORTED;
}
/**
 * Returns the name of the constant behind the media error code.
 */

function getMediaErrorCodeName(error) {
  return MediaErrorType[error.code];
}
/**
 * Serialize an error and all its causes as JSON.
 */

function stringifyError(e) {
  if (typeof e !== 'object' || e === null) {
    return `${e}`;
  }

  const plainObject = toPlainObject(e);
  return JSON.stringify(plainObject);
}
/**
 * Recursively convert objects into plain objects. Designed with built-in
 * errors objects in mind (before cause was explicitly typed to Error), which
 * can't always be serialized directly.
 */

function toPlainObject(obj) {
  const result = {};
  Object.getOwnPropertyNames(obj).concat(['name', 'message', 'stack', 'msExtendedCode']).filter(prop => !/^(\d+|[A-Z_]+)$/.exec(prop)).filter(prop => obj[prop] !== undefined).forEach(prop => {
    if (typeof obj[prop] === 'object' && obj[prop] !== null) {
      result[prop] = toPlainObject(obj[prop]);
    } else {
      result[prop] = obj[prop];
    }
  }); // Special handling of MediaError, which doesn't have a name.

  if (isMediaError(obj)) {
    result.name = 'MediaError';
  }

  return result;
}

export { isError as a, isMediaErrorFatal as b, getMediaErrorCodeName as g, isAbortError as i, stringifyError as s, toError as t };
